import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { ColumnPreset } from '../column-preset.interface';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ColumnBuilderComponent } from '../column-builder/column-builder.component';


@Component({
  moduleId: module.id,
  selector: 'column-builder-modal',
  templateUrl: 'column-builder-modal.component.html',
  styleUrls: ['column-builder-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnBuilderModalComponent extends BaseModalComponent {

  @Input() activeColumns: Array<any> = [];
  @Input() columnsData: Array<any> = [];
  @Input() maxColumns: number = 10;
  @Input() hasColumnsLimit: boolean = true;
  @Input() initialColumnsOrder: Array<string> = [];
  @Input() notRemovableColumns: Array<string> = [];
  @Input() headerTitle: string = 'Select columns';
  @Input() groupedColumns: Array<any> = []; // one column may contain several columns
  @Input() presets: Array<ColumnPreset> = [];

  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild(ColumnBuilderComponent, {static: false})
  columnBuilder: ColumnBuilderComponent | void;

  get selectedColumns(): Array<any> {
    return _.get(this, 'columnBuilder.selectedData', []);
  }

  get disabled(): boolean {
    if (this.hasColumnsLimit) {
      return this.selectedColumns.length > this.maxColumns;
    } else {
      return false;
    }
  }

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  show() {
    super.show();
    _.defer(() => {
      if (this.columnBuilder instanceof ColumnBuilderComponent) {
        this.columnBuilder.setColumns();
      }
      this.ref.markForCheck();
    });
  }

  hide() {
    super.hide();
    if (this.columnBuilder instanceof ColumnBuilderComponent) {
      this.columnBuilder.resetData();
    }
  }

  onSaveBtnClick() {
    if (this.disabled) { return; }
    this.save.emit(this.selectedColumns);
    this.hide();
  }
}
